module.exports = __webpack_public_path__ + "451976cce2ce5a5a80a130e0f03fd95d.MP3";